import { render } from "./FooterStyle.vue?vue&type=template&id=561caedc"
import script from "./FooterStyle.vue?vue&type=script&lang=js"
export * from "./FooterStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__